<template>
  <v-autocomplete
    v-model="value"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    color="primary"
    hide-selected
    item-text="text"
    item-value="id"
    label="Buscar una Orden de Compra"
    return-object
    outlined
    dense
    clearable
    cache-items
    @input="updateValue"
    @change="cambio"
    hide-details
    :disabled="disabled"
    class="modern-input modern-autocomplete"
  >
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center py-1">
        <v-icon x-small color="primary" class="mr-2">fas fa-file-invoice</v-icon>
        <div class="caption font-weight-black primary--text">
          OC-{{item.id}} <span class="grey--text font-weight-medium">— {{item.title}}</span>
        </div>
      </div>
    </template>
    <template v-slot:item="data">
      <div class="d-flex align-center py-2 w-100">
        <v-avatar color="primary lighten-5" size="32" class="mr-3">
          <v-icon color="primary" x-small>fas fa-file-invoice</v-icon>
        </v-avatar>
        <div class="d-flex flex-column overflow-hidden">
          <div class="caption font-weight-black primary--text lh-1 d-flex align-center">
            OC-{{data.item.id}}
            <v-chip x-small outlined color="primary" class="ml-2 font-weight-black px-1" style="height: 16px">APROBADA</v-chip>
          </div>
          <div class="body-2 font-weight-bold grey--text text--darken-3 text-truncate">{{data.item.title}}</div>
          <div class="caption grey--text font-weight-medium text-truncate">{{data.item.provider_name}}</div>
        </div>
      </div>
    </template>
    <template v-slot:no-data>
      <v-list-item class="py-2">
        <div class="text-center w-100">
          <v-icon color="grey lighten-3" size="32" class="mb-2">fas fa-search</v-icon>
          <div class="caption grey--text font-weight-bold uppercase tracking-widest">Ingrese número o título de OC</div>
        </div>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import {fetchPurchase} from '@/api/stocks'
import notifications from '@/utils/notifications'

  export default {
    name:'PurchaseOrderComplete',
    data: () => ({
      descriptionLimit: 60,
      customers: [],
      isLoading: false,
      model: null,
      search:null,
      select:null,
      items: [],
    }),
    props:['value','disabled'],
    methods:{
      updateValue(){
        this.value ? this.$emit('input',this.value) : this.$emit('input','')
      },
      cleared(){
        this.$emit('input','')
      },
      cambio(){
        console.log('cambio en el value')
      },
      async querySelections (v) {
        this.isLoading = true
        //sort = '', page = '', page_size = '', search = '', seller = '', status = ''
        const query=`ordering=-created_at&search=${v}&page=1&&page_size=-1&estatus=2&stock_service=true`
        await fetchPurchase(query)
        .then((res)=>{
          const data = res.results.map(i=>{
            i.text=i.id+i.title+i.provider_name
            return i
          })
          this.items=data
          this.isLoading=false
        })
      },
    },
    watch: {
      search (val) {
        val && val !== this.select && this.querySelections(val)
      },
      
    },
    
    
  }
</script>